<script setup lang="ts">
import { useAppStore } from '@/stores/app'
import { computed } from 'vue'
import type { IRefVideoItem } from '../../types'
import EpisodesPc from './pc.vue'
import EpisodesMobile from './mobile.vue'

const appStore = useAppStore()

const props = defineProps<{
  show: boolean
  scriptId: number
  activeEpisodeId?: number
  episodes?: IRefVideoItem[]
}>()

const emit = defineEmits<{
  (e: 'update:show', value: boolean): void
  (e: 'select-episode', episodeId: number): void
}>()

const mobileShow = computed({
  get: () => props.show,
  set: (value: boolean) => emit('update:show', value),
})
</script>

<template>
  <EpisodesMobile
    v-if="appStore.isMobile"
    v-model:show="mobileShow"
    :script-id="scriptId"
    :active-episode-id="activeEpisodeId"
    @select-episode="emit('select-episode', $event)"
  />

  <EpisodesPc
    v-else-if="show"
    :episodes="episodes"
    :script-id="scriptId"
    :active-episode-id="activeEpisodeId"
    @close="emit('update:show', false)"
    @select-episode="emit('select-episode', $event)"
  />
</template>
